"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentRiskStatus = exports.RiskStatusReason = void 0;
var RiskStatusReason;
(function (RiskStatusReason) {
    // === For ShipmentRiskStatus.AtRisk ===
    // Our Etas predicted driver will be late.
    RiskStatusReason["CarrierIsLikelyToBeLate"] = "carrierIsLikelyToBeLate";
    // Pickup doesn't open til after delivery closes.
    RiskStatusReason["DeliveryClosesBeforePickupCanOccur"] = "deliveryClosesBeforePickupCanOccur";
    // Pickup is closing soon and shipment hasn't been (verifiably) picked up.
    RiskStatusReason["UnlikelyToMakePickup"] = "unlikelyToMakePickup";
    // === For ShipmentRiskStatus.Delayed ===
    // Delivery stop has closed.
    RiskStatusReason["DeliveryStopClosedBeforeDelivery"] = "deliveryStopClosedBeforeDelivery";
    // === For ShipmentRiskStatus.Abandoned ===
    RiskStatusReason["CarrierCouldNotPerformShipment"] = "carrierCouldNotPerformShipment";
})(RiskStatusReason = exports.RiskStatusReason || (exports.RiskStatusReason = {}));
var ShipmentRiskStatus;
(function (ShipmentRiskStatus) {
    ShipmentRiskStatus["OnSchedule"] = "onSchedule";
    // When etaWindowStart > etaWindowEnd
    ShipmentRiskStatus["AtRisk"] = "atRisk";
    // When currentTime > etaWindowEnd
    ShipmentRiskStatus["Delayed"] = "delayed";
    // When shipment was prev allocated then unallocated
    // until the shipment gets re-allocated
    ShipmentRiskStatus["Abandoned"] = "abandoned";
})(ShipmentRiskStatus = exports.ShipmentRiskStatus || (exports.ShipmentRiskStatus = {}));
//# sourceMappingURL=etaStatus.js.map